import React from "react";

import { Typography } from "@/components/Typography";
import { Form } from "@/components/Form";

import { QREditorContextProps, QRProps } from "@/contexts/QREditorContext/types";
import { QREditorContext } from "@/contexts/QREditorContext";

import { applyQRFormDefaultValues } from "@/utils/formHelper";
import { omittedValues } from "@/utils/qrEditorHelper";
import { qrWhatsappValidation } from "@/utils/validators/qr-whatsapp";
import { QRWhatsappProps } from "./types";
import { NAMESPACES } from "@/internals/constants/namespaces";
import { useTranslation } from "react-i18next";
import "./styles.scss";

export const QRWhatsapp = ({ data }: QRWhatsappProps) => {
  const { t } = useTranslation(NAMESPACES.VALIDATIONS);
  const { qrData, setQrData } = React.useContext<QREditorContextProps<"whatsapp">>(QREditorContext);

  const [qrWhatsappData, setQrWhatsappData] = React.useState<QRProps<"whatsapp">>(qrData);
  const [renderForm, setRenderForm] = React.useState(false);

  const dataWhatsapptWithDefaultValues = applyQRFormDefaultValues(data, qrData.data);

  const onUpdateState = ({ field, value }: { field: string; value: string }) => {
    setQrData({ ...qrData, data: { ...qrData.data, [field]: value } }, omittedValues(qrData.data));
  };

  React.useEffect(() => {
    setQrWhatsappData(qrData);
  }, [qrData]);

  React.useEffect(() => {
    setQrData({ ...qrWhatsappData, isValidForm: renderForm });
  }, [renderForm]);

  return (
    <div className="qr-whatsapp">
      <Typography
        Tag="p"
        size="xl"
        classname="u-bold u-spacing-5"
      >
        {data.title}
      </Typography>
      <Form
        fields={dataWhatsapptWithDefaultValues}
        schema={qrWhatsappValidation(data, t)}
        onWatchFields={({ field, value }) => onUpdateState({ field, value })}
        isFormValid={(isValidForm) => setRenderForm(isValidForm)}
      />
    </div>
  );
};
